import React from "react";
import { STATUS_META, PRIORITY_META } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StatusBadge({ status, className }) {
  const m = STATUS_META[status] || STATUS_META.pendiente;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        m.badge,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", m.dot)} />
      {m.label}
    </span>
  );
}

export function PriorityBadge({ priority, className }) {
  const m = PRIORITY_META[priority] || PRIORITY_META.normal;
  return (
    <span
      data-testid={`priority-badge-${priority}`}
      className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide", m.badge, className)}
    >
      {m.label}
    </span>
  );
}
